import { useQuery } from '@tanstack/react-query';
import { mintTaskAttachmentDownloadUrl } from '../services/api/taskAttachments';

/**
 * Quick task 260810-lpq (LPQ-02) — lazy/eager signed-URL mint for
 * task-level attachment downloads. Mirrors `useAttachmentDownloadUrl`
 * (the comment-surface precedent).
 *
 * Server-side TTL is 1 hour; `staleTime` is 50 minutes so a cached URL can
 * never be served past expiry, while still avoiding a re-mint on every
 * render.
 *
 * `disposition: 'attachment'` mints a save-forcing URL (the explicit
 * download control, LPQ-01), distinct from the default view URL — it's part
 * of the query key so the two cache independently.
 */
export function useTaskAttachmentDownloadUrl(
  taskId: number,
  attachmentId: number,
  enabled: boolean,
  disposition?: 'attachment',
) {
  return useQuery<{ url: string; expiresAt: string }>({
    queryKey: ['task-attachment-url', taskId, attachmentId, disposition ?? 'view'],
    queryFn: () => mintTaskAttachmentDownloadUrl(taskId, attachmentId, disposition),
    enabled,
    staleTime: 50 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
